export default {
// The object to be passed as a header for authenticated requests
  getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('id_token'),
      'Accept': 'application/json',
      'Content-type': 'application/json'
    }
  },
  getAuthHeaderFich() {
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('id_token'),
      'Accept': 'application/json',
    }
  }
}